import Sidebar2 from "./Sidebar2";
import Navbar2 from "./Navbar2";
import { connect } from "react-redux";
import { useTheme } from "@mui/styles";
import { Outlet } from "react-router-dom";
import { useUserContext } from "../context/UserContext";
import { AssistantProvider } from "./assistant";
import AssistantPanel from "./assistant/components/AssistantPanel";

const Body = (props) => {
  const theme = useTheme();
  const { userDetails } = useUserContext();
  return (
    <AssistantProvider>
      <div
        style={{
          display: "flex",
          backgroundColor: theme.palette.primary.main,
          height: "100vh",
          width: "100vw",
        }}
      >
        <Sidebar2 {...props} />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            minWidth: 0,
            height: "100%",
            overflow: "hidden",
            position: "relative",
          }}
        >
          <Navbar2 props={props} />
          {/* Under the navbar: page content | assistant column (docked) / full-screen */}
          <div
            style={{
              flex: 1,
              minHeight: 0,
              display: "flex",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <div style={{ flex: 1, minWidth: 0, height: "100%", overflow: "auto" }}>
              <Outlet />
            </div>
            <AssistantPanel userName={userDetails?.user_first_name} />
          </div>
        </div>
      </div>
    </AssistantProvider>
  );
};

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.tk !== null,
    token: state.auth.tk,
    userDetails: state.auth.userDetails,
    authChecked: state.auth.authChecked,
  };
};

export default connect(mapStateToProps)(Body);
